import React from 'react';
import { motion } from 'framer-motion';
import { EyeIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { heroChips, heroTrust } from '../data/hero';
export function Hero() {
  return <header className="bg-radial-glow relative overflow-hidden" data-id="element-86" data-mp="9k0g9cbeknrr">
      <div className="mx-auto max-w-4xl px-5 pb-6 pt-[15px] text-center" data-id="element-87" data-mp="4lqj4w64bd3i">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease: [0.23, 1, 0.32, 1]
      }} className="text-[10px] font-extrabold uppercase tracking-[0.25em] text-grape" data-id="element-88" data-mp="4njnu5x67n8v">
          SIGMA SMART™
        </motion.p>

        <p className="mx-auto mt-3 max-w-2xl font-display text-[22px] font-bold leading-tight text-grape sm:text-[30px]" style={{
        fontFamily: "Montserrat, sans-serif"
      }} data-id="element-89" data-mp="s9zzhikkb8n9">
          REHABILITIEREN SIE JEDE VERLETZUNG SICHER UND PROGRESSIV
        </p>

        
        <p className="pb-[15px] font-display text-xs font-bold uppercase tracking-[0.3em] text-plum/60 sm:text-base" style={{
        paddingTop: "9px",
        paddingBottom: "20px"
      }} data-id="element-90" data-mp="382p73hcojln9">
          Vollständige Genesung durch die klinische Methode der „Medizinischen Enzyklopädie"
        </p>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: [0.23, 1, 0.32, 1]
      }} className="relative mx-auto w-full max-w-2xl" data-id="element-91" data-mp="3o59bpicfn4e0">
          <div className="absolute inset-0 -z-10 mx-auto h-64 w-64 translate-y-6 rounded-full bg-grape/20 blur-3xl" aria-hidden="true" data-id="element-92" data-mp="30gq1gx9tohja" />
          <img src="https://cdn.magicpatterns.com/uploads/hEDJemzarvDqwNRr6uZvCC/ChatGPT_Image_14_sept_2026,_16_36_52.png" alt="DER REHA-CODE 360° — E-Book plus 5 Boni im digitalen Format" width={1536} height={1024} sizes="(min-width: 640px) 672px, 100vw" fetchPriority="high" decoding="async" className="animate-floaty mx-auto h-auto w-full max-w-full rounded-2xl object-contain" data-id="element-93" data-mp="2qk3lomwcsgo4" />
        </motion.div>

        <motion.p initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.05
      }} className="mt-4 text-xs font-semibold uppercase tracking-[0.18em] text-plum/50" style={{
        fontSize: "10px"
      }} data-id="element-94" data-mp="s2jnhxye22k1">
          ⭐ 4.9 (500+ zufriedene Profis und Athleten) · ⚡ Sofortiger Zugriff
        </motion.p>

        <div className="mt-8 flex flex-col items-center" data-id="element-95" data-mp="degfkj0scgsl">
          <CTAButton href="#value" data-id="element-96" data-mp="1b0njdqp9m53w">Jetzt den Reha-Code 360° ansehen</CTAButton>

          <p className="mx-auto mt-4 max-w-2xl text-[14px] text-plum/70 sm:text-lg" data-id="element-97" data-mp="1ayji7gir3k7b">
            KOMPLETTES REHABILITATIONS-SYSTEM 2026. Das Nr. 1 System für Athleten, Trainer und
            Therapeuten, die ein präzises, evidenzbasiertes und sofort einsatzbereites Protokoll
            suchen.
          </p>

          <motion.h2 initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 0.6,
          delay: 0.3
        }} className="mx-auto mt-4 max-w-2xl text-[16px] font-bold text-plum-soft sm:text-xl" data-id="element-98" data-mp="3lsyun4p58wlp">
            Schulter · Knie · Knöchel · Wirbelsäule · Hüfte · Ellbogen
          </motion.h2>

          <div className="mt-6 flex flex-wrap justify-center gap-2.5" data-id="element-99" data-mp="21bfulng27bte">
            {heroChips.map(({
            icon: Icon,
            label
          }) => <span key={label} className="inline-flex items-center gap-1.5 rounded-full border border-grape/20 bg-white/70 px-3.5 py-1.5 text-xs font-semibold text-plum/80" data-id="element-100" data-mp="2b0fvjce4gha8">
                <Icon className="h-3.5 w-3.5 text-grape" data-id="element-101" data-mp="2g1wuv3gyjvop" />
                {label}
              </span>)}
          </div>

          <p className="mt-4 text-sm font-semibold text-plum/50" data-id="element-102" data-mp="2p0h6jko3p53f">
            Hauptwerk + 5 Boni · 160+ Seiten — Alles an einem Ort.
          </p>
        </div>

        <div className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs font-medium text-plum/55" data-id="element-103" data-mp="2tz20518ukqiw">
          {heroTrust.map(({
          icon: Icon,
          label
        }) => <span key={label} className="inline-flex items-center gap-1.5" data-id="element-104" data-mp="zm2mhdo126e9">
              <Icon className="h-4 w-4 text-grape" data-id="element-105" data-mp="4acmxeox1t8h" />
              {label}
            </span>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.05,
        ease: [0.23, 1, 0.32, 1]
      }} className="mt-5 inline-flex items-center gap-2 rounded-full border border-blush/50 bg-blush-soft px-4 py-1.5 text-xs font-bold uppercase tracking-wide text-blush-deep" data-id="element-106" data-mp="3vgvu8jvjn121">
          🔥 Zeitlich begrenztes Angebot · Danach steigt der Preis wieder auf €54
        </motion.div>

        <p className="mt-4 inline-flex items-center justify-center gap-1.5 text-xs font-medium text-plum/45" data-id="element-107" data-mp="3rgvgz2k6kvwk">
          <EyeIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-108" data-mp="3mnslgovufcdq" />
          47 Personen sehen sich dieses Produkt gerade an
        </p>
      </div>
    </header>;
}